export { default } from "./CardBasic"
